import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownCircleOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';

class Action extends React.Component {
    render() {
        const { row, action, modalForm, modalDetail } = this.props;
        const items = [];

        if (!action.update && !action.detail) {
            return "-"
        }

        if (action.detail) {
            items.push({
                key: '1',
                label: "Detail",
                icon: <InfoCircleOutlined />,
                onClick: () => {
                    modalDetail(true, row)
                },
            })
        }

        if (action.update) {
            items.push({
                key: '2',
                label: "Update",
                onClick: () => {
                    console.log("Opening modal for row:", row);
                    modalForm(true, row)
                },
                icon: <EditOutlined />,
            })
        }

        return (
            <Dropdown
                trigger={['click']}
                menu={{ items }}
            >
                <Button type="primary">
                    Opsi <DownCircleOutlined style={{ fontSize: 11 }} />
                </Button>
            </Dropdown>
        );
    }
}


export default Action;
